module.exports = __webpack_public_path__ + "static/media/Easy-Run-Logo-Header-5.df18c440.png";